import actions from "@/store/modules/users/experience/actions";
import { mutations, state } from "@/store/modules/users/experience/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
